import React from 'react'
import { Row, Col } from 'reactstrap'

import TableContainer from '@material-ui/core/TableContainer'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import Paper from '@material-ui/core/Paper'
import { OrderedWineItem } from './orderedWineItem'

export const OrderedWines = ({ localize, entity, classes, onDeliveredUnitsChange, onActualPriceChange, disabled  }) => {
  const { currencyName, exchangeRate } = entity
  return (
    <Row>
      <Col>
        <Paper elevation={5}>
          <Table><TableHead><TableRow><TableCell>{localize('orders.orderedWines')}</TableCell></TableRow></TableHead></Table>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>{localize('ordersProcessing.wineName')}</TableCell>
                  <TableCell align='right'>{localize('ordersProcessing.orderedUnits')}</TableCell>
                  <TableCell align='center'>{localize('ordersProcessing.deliveredUnits')}</TableCell>
                  <TableCell align='right'>{localize('ordersProcessing.priceInOrder')}</TableCell>
                  <TableCell align='center'>{localize('ordersProcessing.actualPrice')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {entity.deliveredWines.map((wine, index) => <OrderedWineItem
                  key={index}
                  item={wine}
                  currencyName={currencyName}
                  exchangeRate={exchangeRate}
                  index={index}
                  disabled={disabled}
                  onDeliveredUnitsChange={onDeliveredUnitsChange}
                  onActualPriceChange={onActualPriceChange}
                  />)}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
      </Col>
    </Row>
  )
}